<div class="position-relative d-flex p-3 p-md-5 m-md-3 text-center bg-dark intro-banner">
  <div class="col-md-8 p-lg-5 mx-auto text-white align-self-center">
    <h1 class="display-5 font-weight-bold mx-auto">{{'Secteur manufacturier' | translate}}</h1>
  </div>
</div>
<contact-us-btn></contact-us-btn>
<hr class="mb-5 mt-3">
<div class="container">
    <div class="text-center my-5 mb-5">
        <span class="title sub-bar">{{'Analyse du secteur manufacturier' | translate}}</span>
    </div>
    <div class="container justif-center my-5">
      <p><span class="bold-blue">{{ 'Les industries manufacturières' | translate}}</span> {{ 'sont des industries de transformation de biens, qui sont principalement des industries manufacturières pour compte propre, mais qui comprennent également la réparation et l’installation d’équipements industriels ainsi que des opérations de sous-traitance pour un tiers (INSEE).' | translate}}</p>
    </div>
</div>
<div class="block-free-access py-5">
    <div class="container px-5">
        <div class="block p-0">
            <ul class="nav landing-tabs" id="myTab" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" id="global-tab" data-toggle="tab" href="#global" role="tab" aria-controls="global" aria-selected="true" title="World">
                        <div class="icon">
                          <picture>
            									<source srcset="/assets/world_icon.webp" type="image/webp">
                              <source srcset="/assets/world_icon.png" type="image/png">
            									<img src="/assets/world_icon.png" class="pays" alt="Global manufacturing sector trends: Accidentology and Market Analysis" title="World" loading="lazy"/>
            							</picture>
                        </div>
                        <b class="text-uppercase">{{'Global' | translate}}</b>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="usa-tab" data-toggle="tab" href="#usa" role="tab" aria-controls="usa" aria-selected="false" title="USA">
                        <div class="icon">
                          <picture>
            									<source srcset="/assets/usa_icon.webp" type="image/webp">
                              <source srcset="/assets/usa_icon.png" type="image/png">
            									<img src="/assets/usa_icon.png" class="pays" alt="United States manufacturing sector trends: Accidentology and Market Analysis" title="USA" loading="lazy"/>
            							</picture>
                        </div>
                        <b class="text-uppercase">{{'Etats-Unis' | translate}}</b>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="france-tab" data-toggle="tab" href="#france" role="tab" aria-controls="france" aria-selected="false" title="France">
                        <div class="icon">
                          <picture>
            									<source srcset="/assets/france_icon.webp" type="image/webp">
                              <source srcset="/assets/france_icon.png" type="image/png">
            									<img src="/assets/france_icon.png" class="pays" alt="French manufacturing sector trends: Accidentology and Market Analysis" title="France" loading="lazy"/>
            							</picture>
                        </div>
                        <b class="text-uppercase">{{'France' | translate}}</b>
                    </a>
                </li>
            </ul>
            <hr class="my-0">
            <div class="tab-content text-center py-4 px-3 px-md-5" id="myTabContent">
                <div class="tab-pane fade show active" id="global" role="tabpanel" aria-labelledby="global-tab">
                    <b class="sub-bar">{{'GLOBAL' | translate}}</b>
                    <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'ACCIDENTS :' | translate}}</p>
                    <ul class="mb-0 mt-2 text-justify">
                      <li>{{'2,3 millions de personnes dans le monde meurent chaque année à cause d’accidents ou de maladies liés au travail, ce qui correspond à plus de 6000 décès par jour ' | translate}}<a class="source" href="https://www.ilo.org/moscow/areas-of-work/occupational-safety-and-health/WCMS_249278/lang--en/index.htm" target="_blank" rel="noopener nofollow" title="ilo">{{'(source)' | translate}}</a></li>
                      <li>{{'250 millions d’accidents avec une absence du travail se produisent chaque année, soit l’équivalent de 685 000 accidents par jour, 475 par minute et 8 par seconde ' | translate}}<a class="source" href="https://www.ilo.org/global/about-the-ilo/newsroom/news/WCMS_007969/lang--en/index.htm" target="_blank" rel="noopener nofollow" title="ilo">{{'(source)' | translate}}</a></li>
                    </ul>
                    <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'MARCHÉ :' | translate}}</p>
                    <ul class="mb-0 mt-2 text-justify">
                      <li>{{'La valeur ajoutée manufacturière représente 15,40 % du PIB mondial (2018).' | translate}} <a class="source" href="https://data.worldbank.org/indicator/NV.IND.MANF.ZS?locations=1W" target="_blank" rel="noopener nofollow" title="data worldbank">{{'(source)' | translate}}</a></li>
                    </ul>
                </div>
                <div class="tab-pane fade" id="usa" role="tabpanel" aria-labelledby="usa-tab">
                  <b class="sub-bar">{{'ETATS-UNIS' | translate}}</b>
                  <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'ACCIDENTS :' | translate}}</p>
                  <ul class="mb-0 mt-2 text-justify">
                    <li>{{'Le coût total direct et indirect des accidents du travail s’élève à 128 milliards de dollars.' | translate}} <a class="source" href="https://www.ishn.com/articles/110379-understanding-direct-and-indirect-costs-of-machinery-accidents" target="_blank" rel="noopener nofollow" title="ishn">{{'(source)' | translate}}</a></li>
                    <li>{{'Aux États-Unis, les travailleurs qui utilisent ou entretiennent des machines industrielles subissent chaque année plus de 18 000 amputations, écrasements de doigts et autres lésions traumatiques.' | translate}} <a class="source" href="https://www.osha.gov/etools/machine-guarding" target="_blank" rel="noopener nofollow" title="osha">{{'(source)' | translate}}</a></li>
                  </ul>
                  <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'MARCHÉ :' | translate}}</p>
                  <ul class="mb-0 mt-2 text-justify">
                    <li>{{'Les fabricants représentent 11,39 % de la production totale de l’économie, employant 8,51 % de la main-d’oeuvre. La production totale de l’industrie manufacturière était de 2 334,60 milliards de dollars en 2018.' | translate}} <a class="source" href="https://www.nam.org/state-manufacturing-data/2020-united-states-manufacturing-facts/" target="_blank" rel="noopener nofollow" title="nam">{{'(source)' | translate}}</a></li>
                  </ul>
                </div>
                <div class="tab-pane fade" id="france" role="tabpanel" aria-labelledby="france-tab">
                  <b class="sub-bar">{{'FRANCE' | translate}}</b>
                  <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'ACCIDENTS :' | translate}}</p>
                  <ul class="mb-0 mt-2 text-justify">
                    <li>{{'En 2018, il y a eu environ 2 800 accidents mortels pour 100 000 personnes employées ' | translate}}<a class="source" href="https://ec.europa.eu/eurostat/statistics-explained/index.php?title=Accidents_at_work_statistics#Data_sources" target="_blank" rel="noopener nofollow" title="europa statistics">{{'(source)' | translate}}</a></li>
                    <li>{{'En 2018, il y a eu 3 445 accidents non mortels pour 100 000 personnes employées ' | translate}}<a class="source" href="https://ec.europa.eu/eurostat/statistics-explained/index.php?title=Accidents_at_work_statistics#Data_sources" target="_blank" rel="noopener nofollow" title="europa statistics">{{'(source)' | translate}}</a></li>
                  </ul>
                  <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'MARCHÉ :' | translate}}</p>
                  <ul class="mb-0 mt-2 text-justify">
                    <li>{{'En 2018, 2,8 millions d’employés travaillaient dans le secteur manufacturier, ce qui représente 11 % de l’économie totale.' | translate}} <a class="source" href="https://www.insee.fr/fr/statistiques/4188611" target="_blank" rel="noopener nofollow" title="insee">{{'(source)' | translate}}</a></li>
                  </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container my-5">
    <div class="text-center mb-5">
        <span class="title sub-bar">{{'Challenges du secteur' | translate}}</span>
    </div>
    <div class="row pt-4">
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><app-svg-icon [src]="'assets/svg/1-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'La sécurité des employés devient une priorité absolue :' | translate}}</p>
                <p class="text-justify">{{'La sécurité sur le lieu de travail est la principale tendance des fabricants à l’horizon 2021, car elle a pris une nouvelle importance à la lumière de la pandémie. De nouvelles mesures de sécurité sont mises en pratique, telles que les mesures de distanciation sociale sur le lieu de production, la désinfection des espaces de travail, la surveillance des personnes qui entrent et sortent des installations, ainsi que des personnes ou des équipements avec lesquels elles interagissent.' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment la solution d’Immersive Factory aide à surmonter ce défi :' | translate}}</p>
                  {{'Catalogue de plus de 30 exercices d’apprentissage immersifs qui permettent un apprentissage plus rapide et plus efficace que la formation traditionnelle pour réduire efficacement le nombre d’accidents.' | translate}}
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/femme_VR_V2.webp" type="image/webp">
                <source srcset="assets/femme_VR_V2.jpg" type="image/jpg">
                <img src="assets/femme_VR_V2.jpg" class="block-rounded abstract-formation" alt="A woman using a VR headset to train for EHS risks" title="VR Safety training" loading="lazy">
            </picture>
        </div>
    </div>
    <hr class="px-2 mb-4">
    <div class="row pt-4">
        <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/multi_supports.webp" type="image/webp">
                <source srcset="assets/multi_supports.jpg" type="image/jpg">
                <img src="assets/multi_supports.jpg" class="block-rounded abstract-formation" alt="Immersive Factory virtual campus is available on PC and Mac" title="Multi-support" loading="lazy">
            </picture>
        </div>
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><app-svg-icon [src]="'assets/svg/2-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'Vers l’industrie 5.0. :' | translate}}</p>
                <p class="text-justify">{{'Connecter l’homme et la machine : collaboration entre les humains et les systèmes intelligents. Utiliser les technologies numériques. Les fabricants devraient utiliser les nouvelles technologies numériques qui les aident à devenir plus efficaces, plus résilients et plus agiles pour se préparer à la prochaine normalité.' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment la solution d’Immersive Factory aide à surmonter ce défi :' | translate}}</p>
                  {{'Plate-forme numérique immersive 3D et VR. L’aspect multi-appareils permet à chaque apprenant de se former où qu’il soit.' | translate}}
                </div>
            </div>
        </div>
    </div>
    <hr class="px-2 my-4">
    <div class="row pt-4">
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><app-svg-icon [src]="'assets/svg/3-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'Ré-architecturer le travail, la main-d’oeuvre et le lieu de travail pour gérer les perturbations :' | translate}}</p>
                <p class="text-justify">{{'Dans un sondage Deloitte (2021), 61% des dirigeants interrogés prévoient de développer un modèle hybride pour leurs processus de production et de non-production au cours des trois prochaines années.' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment la solution d’Immersive Factory aide à surmonter ce défi :' | translate}}</p>
                  {{'Outil personnalisable permettant la cohérence des actions de chaque site sur un seul outil, et multi-device permettant à chaque apprenant de se former en toute sécurité, où qu’il soit. Back-office intuitif et accès en temps réel aux indicateurs clés de performance (ICP) permettant un suivi constant des efforts et des réalisations des équipes.' | translate}}
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6 mb-md-4 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/{{'pharma-proteger-accidents' | translate}}.webp" type="image/webp">
                <source srcset="assets/{{'pharma-proteger-accidents' | translate}}.png" type="image/png">
                <img src="assets/{{'pharma-proteger-accidents' | translate}}.png" class="block-rounded" alt="VR training workshops increase learner memory by 4" title="EHS VR trainings" loading="lazy">
            </picture>
        </div>
    </div>
    <hr class="px-2 my-4">
    <div class="row pt-4">
        <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/Reporting_Moyenne_Horizontal_V2.webp" type="image/webp">
                <source srcset="assets/Reporting_Moyenne_Horizontal_V2.jpg" type="image/jpg">
                <img src="assets/Reporting_Moyenne_Horizontal_V2.jpg" class="block-rounded abstract-formation mb-4" alt="Website backoffice: reporting and statistics" title="Back-office" loading="lazy">
            </picture>
            <picture>
                <source srcset="assets/IFSE_Inversee.webp" type="image/webp">
                <source srcset="assets/IFSE_Inversee.jpg" type="image/jpg">
                <img src="assets/IFSE_Inversee.jpg" class="block-rounded abstract-formation" alt="Visual from outside the virtual campus" title="Virtual Campus" loading="lazy">
            </picture>
        </div>
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><app-svg-icon [src]="'assets/svg/4-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'Prévention des accidents industriels :' | translate}}</p>
                <p class="text-justify">{{'La formation à la sécurité est le premier moyen de prévention des accidents du travail. Les mesures de distanciation sociale continuant à jouer un rôle essentiel dans la protection de notre bien-être, on constate un besoin croissant de professionnels expérimentés dans la conception de processus solides en matière de santé et de sécurité.' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment la solution d’Immersive Factory aide à surmonter ce défi :' | translate}}</p>
                  {{'Immersive Factory propose un vaste catalogue d’exercices permettant à vos collaborateurs de se former en totale autonomie. En effet, plus de 30 exercices gamifiés sont à votre disposition pour un apprentissage rapide et immersif. Par le biais d’une approche originale et ludique, et, au travers d’un environnement virtuel réaliste, les travailleurs peuvent se confronter aux risques qu’ils peuvent potentiellement rencontrer sur leur lieu de travail. Nos formations actives et serious games sont disponibles en réalité virtuelle ou en simulation 3D sur PC. Par ailleurs, notre back office ergonomique permet de suivre en temps réel toutes les KPIs et statistiques inhérentes aux actions menées par les équipes (erreurs de procédure commises, comparaison des résultats entre les différents sites, etc..). Notre campus virtuel, entièrement personnalisable, vous permet aussi d’organiser et d’animer vos journées sécurité et évènements HSE à distance. Nul besoin de rapprochement physique entre les participants, les règles de distanciation sociale sont ainsi respectées.' | translate}}
                </div>
            </div>
        </div>
    </div>
    <hr class="px-2 my-4">
    <div class="row pt-4">
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><app-svg-icon [src]="'assets/svg/5-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'Compétences et formation :' | translate}}</p>
                <p class="text-justify">{{'Les avantages des programmes d’apprentissage en tant que moyen d’éduquer et de responsabiliser les employés et de combler le manque de compétences dans le secteur manufacturier bénéficient d’un soutien retentissant. Une grande majorité des personnes interrogées (86%) conviennent que les fabricants ont la responsabilité de s’impliquer davantage dans les écoles et la formation. 72 % des fabricants considèrent le développement de l’apprentissage comme un élément positif pour l’industrie manufacturière, 71% estimant que les programmes d’apprentissage offrent une alternative viable aux autres formes d’enseignement supérieur pour les jeunes en fin de scolarité.' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment la solution d’Immersive Factory aide à surmonter ce défi :' | translate}}</p>
                  {{'Un très large pannel d’activités en VR ou en simulation 3D sur PC offrant aux travailleurs une immersion totale durant laquelle ils seront pleinement actifs et 4 fois plus concentrés et impliqués émotionnellement que leurs homologues face à une formation transmissive classique (PwC, 2020).' | translate}}
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6 mb-md-4 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/{{'gif-fr-competences-formations' | translate}}.webp" type="image/webp">
                <source srcset="assets/{{'gif-fr-competences-formations' | translate}}.gif" type="image/gif">
                <img src="assets/{{'gif-fr-competences-formations' | translate}}.gif" class="block-rounded" alt="An immersive 3d virtual campus" title="Remote EHS events" loading="lazy">
            </picture>
        </div>
    </div>
</div>
<hr class="mt-4 mb-0 pb-0">
<div class="grey py-5">
  <div class="container text-justify">
      <div class="text-center mb-5">
          <span class="title sub-bar">{{'Qu’est-ce que le Lean Manufacturing ?' | translate}}</span>
      </div>
      <p>{{"Le Lean Manufacturing est une méthodologie de production qui met l’accent sur la réduction des coûts de production. Dans un contexte de production allégée, chaque processus et activité sont conçus pour ajouter de la valeur pour le client et éliminer les gaspillages" | translate}}.</p>
      <p>{{"Il existe de nombreux types de gaspillages (de temps, de matériaux, etc) qui peuvent se produire dans un contexte de fabrication. L’objectif du Lean Manufacturing est d’identifier et d’éliminer autant de pertes que possible. Ce faisant, les fabricants sont en mesure d’accroître l’efficacité et la productivité de leurs employés, ainsi que la qualité des produits" | translate }}.</p>
      <p>{{"L’un des concepts clés de la production allégée est connu sous le nom des 'cinq S' Il s’agit des cinq éléments d’organisation nécessaires à un environnement de production 'Lean' : ELIMINER (ce dont on n’a pas besoin), RANGER, NETTOYER, STANDARDISER, RESPECTER" | translate }}.</p>
      <p>{{"La mise en place du Lean Manufacturing peut être un défi pour toute organisation, mais les avantages sont considérables. Les organisations qui ont réussi à mettre en œuvre ce processus constatent une augmentation de la productivité des employés, de la qualité des produits et de la satisfaction des clients. En outre, il a été démontré que le Lean Manufacturing réduit les coûts de production et les délais" | translate }}.</p>
  </div>
</div>
<hr class="mb-4 mt-0 pt-0">
<div class="container my-5">
    <div class="text-center mb-5">
        <span class="title sub-bar">{{'Pourquoi choisir Immersive Factory pour former vos employés à la sécurité et au Lean Manufacturing ?' | translate}}</span>
    </div>
    <div class="row d-flex align-items-center">
      <div class="col-12 col-md-6 px-4 mb-md-0 mb-4">
          <picture>
              <source srcset="assets/Formation-homme-vr2.webp" type="image/webp">
              <source srcset="assets/Formation-homme-vr2.jpg" type="image/jpg">
              <img src="assets/Formation-homme-vr2.jpg" class="block-rounded" alt="A man using a VR headset to train for EHS hazards" title="VR training" loading="lazy">
          </picture>
      </div>
      <div class="text-justify col-12 col-md-6 px-4">
        <p>{{"Nous proposons des formations en réalité virtuelle engageantes pour vos employés. Vous pouvez ainsi créer, avec notre équipe d’experts, des modules de formations sur mesure adaptées au secteur de la manufacture" | translate}}.</p>
        <p>{{"Les modules créés peuvent alors être utilisés et sont mis à dispositions des employés d’une manières étendue au sein de l’entreprise" | translate }}.</p>
        <p class="pb-0 mb-0">{{"Grâce à la VR, nos modules sont simples à mettre en œuvre, et surtout beaucoup plus efficaces qu’une formation classique" | translate }}.</p>
      </div>
    </div>
</div>
<hr *ngIf="blocnews" class="mb-4 mt-0 pt-0">
<div *ngIf="blocnews" class="container">
    <div class="text-center my-5 mb-5">
        <span class="title sub-bar">{{'Envie d’en savoir plus sur les avantages qu’offre l’immersive learning pour le secteur manufacturier ?' | translate}}</span>
    </div>
    <div class="container my-5">
      <p class="justif-center">{{ 'Venez les découvrir au travers du témoignage d’Imerys qui a co-développé avec Immersive Factory un module de formation en réalité virtuelle pour sensibiliser leurs équipes aux risques professionnels manufacturiers :' | translate}}</p>
      <div *ngIf="blocnews" class="mt-4">
        <div class="post row pr-0">
            <div class="col-12 col-md-6 mb-md-0 px-0">
                <a *ngIf="blocnews['link']" [routerLink]="language.navigateAccordingToLang([blocnews['link']])" target="blank" rel="noopener nofollow" title="{{blocnews['title']}}"><img src='{{blocnews.imageHeader}}' class="news-image abstract-formation" alt="Imerys Testimonial: looking back on the creation of a VR module" title="Imerys Testimonial" loading="lazy"></a>
            </div>
            <div class="col-12 col-md-6 px-4 pt-4 mb-4 d-flex justify-content-center align-items-center">
                <div>
                    <p *ngIf="blocnews['title']" class="font-weight-bold ifsolution">{{blocnews["title"]}}</p>
                    <div class="informations my-3">
                        <span *ngIf="blocnews['createdDate']" class="date">{{blocnews["createdDate"]}}</span>
                        <div *ngIf="blocnews.tag['title']" class="tag rounded px-2">{{blocnews.tag["title"]}}</div>
                    </div>
                    <div class="actu-body">
                      <p *ngIf="blocnews['shortDesc']" class="description" [innerHTML]="blocnews['shortDesc']"></p>
                      <a *ngIf="blocnews['link']" [routerLink]="language.navigateAccordingToLang([blocnews['link']])" class="viewmore mb-3" target="blank" rel="noopener nofollow" title="{{blocnews['title']}}">{{'Voir plus' | translate}}</a>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
</div>


<hr class="mt-5">
<div class="reassurance">
    <div class="container py-4 mb-4">
        <h3 class="my-4">{{ 'Ils nous font confiance' | translate}}</h3>
        <owl-carousel
            [options]="{
                items: 5,
                dots: false,
                nav: true,
                margin:0,
                loop:true,
                autoplay:true,
                autoplayTimeout:3000,
                autoplayHoverPause:true,
                responsive:{
                    '300':{
                        items:1,
                        nav:true
                    },
                    '768':{
                        items:3,
                        nav:true
                    },
                    '992':{
                        items:5,
                        nav:true,
                        loop:true
                    }
                }
            }"
            [carouselClasses]="['owl-carousel']">
            <div class="logos-theytrustus" *ngFor="let image of images;let i = index">
                <picture>
                    <source srcset="{{image.url}}.webp" type="image/webp">
                    <source srcset="{{image.url}}.png" type="image/png">
                    <img src="{{image.url}}.png" [attr.alt]="image.alt" [attr.title]="image.title" loading="lazy">
                </picture>
            </div>
        </owl-carousel>
    </div>
</div>
<hr class="my-4">


<div class="container mb-5">
    <div class="text-center my-5 mb-5">
        <span class="title sub-bar">{{'exercices dédiés au secteur manufacturier' | translate}}</span>
    </div>
    <div *ngIf="listProducts" class="mt-4">
        <div class="row ml-0 mr-0">
          <app-product-card class="col-md-4 mt-4"  *ngFor="let product of listProducts" [product]="product"></app-product-card>
        </div>
    </div>
</div>
<!-- TEMOIGNAGE CLIENT
<hr class="my-4">
<div class="container">
    <div class="text-center my-5 mb-5">
        <span class="title sub-bar">{{'Témoignage client' | translate}}</span>
    </div>

    <div class="container-fluid mb-5">
        <div class="row">
            <div class="col-md-6 col-12 latest-pub">
                <h2 class="title-pub bold px-4 pt-2">{{'Téléchargez notre dernier témoignage client' | translate}}</h2>
                <h3 class="text-pub mt-2 px-4">{{'Témoignage EGIS' | translate}}</h3>
                <a href="https://communication.immersivefactory.com/Egis_Testimonial.pdf" target="_blank">
                <div class="download-btn mt-4">
                    <i class="fas fa-download"></i><span class="ml-2">{{'Télécharger' | translate}}</span>
                </div>
                </a>
            </div>
            <div class="col-md-6 col-12 book">
                <div class="magasine magasine-{{language.lang}}">
                </div>
            </div>
        </div>
    </div>
</div>
-->
